export default __webpack_public_path__ + "/dist/images/get-2.130f40716e273f6d2e58d4a8d09a39c9.png";